import './index.scss'
import React, { useEffect } from 'react'
import Loader from 'react-loaders'
import AnimatedLetters from '../AnimatedLetters'
import { useState } from 'react'
import { useRef } from 'react'
import emailjs from '@emailjs/browser'
import { MapContainer, TileLayer, useMap, Marker, Popup } from 'react-leaflet'

const Contact = () => {
  const [letterClass, setLetterClass] = useState('text-animate')

  const refForm = useRef()

  useEffect(() => {
    setTimeout(() => {
      setLetterClass('text-animate-hover')
    }, 3000)
  }, [])

  const sendEmail = (e) =>{
    e.preventDefault()

    emailjs
    .sendForm(
        'service_cpz8ylw',
        'template_x2r2fri',
        refForm.current,
        "2JXUOsr6ww4jXycHp",
    )
    .then(
        () =>{
            alert('Message successfully sent')
            window.location.reload(false)
        },
        () => {
            alert('Failed to send the message, please try again')
        }
    )
  }
  return (
    <>
      <div className="container contact-page">
        <div className="text-zone">
          <h1>
            <AnimatedLetters
              letterClass={letterClass}
              strArray={['C', 'o', 'n', 't', 'a', 'c', 't', ' ', 'm', 'e']}
              idx={15}
            />
          </h1>
          <p>
            I am interested in freelance opportunities, especially ambitious or
            large projects. However, if you have other request or questions,
            don't hesitate to contact me using the below form either.
          </p>
          <div className="contact-form">
            <form ref={refForm} onSubmit={sendEmail}>
              <ul>
                <li className="half">
                  <input type="text" name="name" placeholder="Name" required />
                </li>
                <li className="half">
                  <input
                    type="email"
                    name="email"
                    placeholder="Email"
                    required
                  />
                </li>
                <li>
                  <input
                    placeholder="Subject"
                    name="subject"
                    type="text"
                    required
                  />
                </li>
                <li>
                  <textarea
                    name="message"
                    placeholder="Message"
                    required
                  ></textarea>
                </li>
                <li>
                    <input type="submit" className='flat-button' value='SEND' />
                </li>
              </ul>
            </form>
          </div>
        </div>
        <div className='info-map'>
          Daniel Nwachukwu
          <br />
          Nigeria
          <br />
          Harbor Point Estate, Ijora Olopa <br />
          Lagos State.
           <br />
           <span>Nwachukwusogidechi@gmail.com</span>
        </div>
        <div className="map-wrap">
          <MapContainer center={[6.46923,3.37582]} zoom={13}>
            <TileLayer  url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"/>
            <Marker position={[6.46923,3.37582]}>
              <Popup>I live here :)</Popup>
            </Marker>
          </MapContainer>
        </div>
      </div>
      <Loader type="pacman" />
    </>
  )
}

export default Contact
